module.exports = __webpack_public_path__ + "static/media/inventory-tutorial-5.92504c6b.png";